// Cookie position Ayu 2021/02/11
const actionElement = document.getElementById("cookie-banner_flag__fingerprint");
const ua = navigator.userAgent;
if (ua.indexOf('iPhone') > -1 || (ua.indexOf('Android') > -1 && ua.indexOf('Mobile') > -1)) {
    // mb
    $(document).ready(function(){
        $(window).scroll(function(){
            if($(window).scrollTop() > 50){
              
                $('#cookie-banner_flag').addClass("cookie-remove")
              
            }else{
                $('#cookie-banner_flag').removeClass("cookie-remove")
            }
        });
});
} else if (ua.indexOf('iPad') > -1 || ua.indexOf('Android') > -1) {
    // tablet
    $(document).ready(function(){
    $('#cookie-banner_flag').addClass("cookie-active")
});
} else {
    // PC
    $(document).ready(function(){
    $('#cookie-banner_flag').addClass("cookie-active")
});
}